// extracted by css-extract-rspack-plugin
export default {"container":"index__container___WTnua","title":"index__title___JnOYr","caption":"index__caption___yfO2h"};